"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignDerivedStatusToJSON = exports.CampaignDerivedStatusFromJSONTyped = exports.CampaignDerivedStatusFromJSON = exports.CampaignDerivedStatus = void 0;
/**
 * Current derived state of campaign.
 * @export
 */
exports.CampaignDerivedStatus = {
    Active: 'ACTIVE',
    Rejected: 'REJECTED',
    Ready: 'READY',
    Completed: 'COMPLETED',
    PendingApproval: 'PENDING_APPROVAL',
    PendingAdvertiserApproval: 'PENDING_ADVERTISER_APPROVAL',
    Stopped: 'STOPPED',
    Unknown: 'UNKNOWN'
};
function CampaignDerivedStatusFromJSON(json) {
    return CampaignDerivedStatusFromJSONTyped(json, false);
}
exports.CampaignDerivedStatusFromJSON = CampaignDerivedStatusFromJSON;
function CampaignDerivedStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignDerivedStatusFromJSONTyped = CampaignDerivedStatusFromJSONTyped;
function CampaignDerivedStatusToJSON(value) {
    return value;
}
exports.CampaignDerivedStatusToJSON = CampaignDerivedStatusToJSON;
